import Snackbar from '@mui/material/Snackbar';
import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useState } from 'react';
import { Alert } from '@mui/lab';
import { NoticeProp, NoticeRef, NoticeSnackbarType, NoticeViewModel } from './types';
import IconButton from '@mui/material/IconButton/IconButton';
import { Close } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const Item = styled(Paper)(({ theme }) => ({
  root: {
    border: 0,
    borderStyle: 'none',
  },
  textAlign: 'center',
  color: theme.palette.text.secondary,
  borderStyle: 'none',
  boxShadow: 'none',
}));

const Notice: ForwardRefRenderFunction<NoticeRef, NoticeProp> = (props, ref) => {
  const [state] = useState<NoticeSnackbarType>({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal } = state;

  const [view, setViewModel] = useState<NoticeViewModel>({
    Message: '',
    Open: false,
    TypeInfo: 'info',
  });

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    setViewModel({ ...view, Open: false });
  };

  const ReplaceStr = (replaceStr: string): string => {
    if (replaceStr === undefined || replaceStr === null) {
      return '';
    }

    let result = replaceStr;

    const replaceString: string = '\r\n';
    const replaceString2: string = '\n';

    // 如果想要替换所有指定的字符串，可以用while循环
    while (result.indexOf(replaceString) >= 0 || result.indexOf(replaceString2) >= 0) { // 判断a字符串中是否包含'c'，如果包含就替换掉，然后继续判断是否包含C，包含就替换继续判断，不包含就结束循环
      result = result.replace(replaceString, '<br />');
      result = result.replace(replaceString2, '<br />');
    }

    return result;
  };

  useImperativeHandle(ref, () => ({
    Show: (inProp) => {
      inProp.Message = ReplaceStr(inProp.Message ?? '');
      setViewModel({ ...inProp });
    },
  }));

  const typeList: Array<{ TypeInfo: 'error' | 'warning' | 'info' | 'success', backgroundColor: string }> = [
    { TypeInfo: 'error', backgroundColor: '#FDEDED' },
    { TypeInfo: 'warning', backgroundColor: '#FFF4E5' },
    { TypeInfo: 'info', backgroundColor: '#E5F6FD' },
    { TypeInfo: 'success', backgroundColor: '#EDF7ED' },
  ];

  return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={view.Open}
                onClose={handleClose}
                key={vertical + horizontal}
            >
                <div>
                    <Alert severity={view.TypeInfo} closeText={'Close'}>
                        <Stack spacing={1}>
                            <Item style={{
                              backgroundColor: typeList.find(p => p.TypeInfo === view.TypeInfo)?.backgroundColor ?? '#ffffff',
                            }}>
                                <div dangerouslySetInnerHTML={{ __html: view.Message ?? '' }}/>
                            </Item>
                            <Item style={{
                              backgroundColor: typeList.find(p => p.TypeInfo === view.TypeInfo)?.backgroundColor ?? '#ffffff',
                            }}
                                  onClick={handleClose}
                            >
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    sx={{ p: 0.5 }}
                                >
                                    <Close fontSize={'small'}/>
                                </IconButton>
                            </Item>
                        </Stack>
                    </Alert>
                </div>
            </Snackbar>
        </div>
  );
};
export default forwardRef(Notice);
